import React from 'react';
import ReactDOM from 'react-dom/client';
import FormCompnent from './FormCompnent';
import './bootstrap-scoped.scss';

const elements = document.querySelectorAll('.form-component');

// Create and render a root for each element
elements.forEach(element => {
    const root = ReactDOM.createRoot(element);
    root.render(<React.StrictMode>
      <FormCompnent domId = {element.id}/>     
    </React.StrictMode>);
});


